const iconNameMap = {
  'el-icon-search': 'search',
  'el-icon-edit': 'edit',
  'el-icon-edit-outline': 'edit',
  'el-icon-check': 'success',
  'el-icon-close': 'cross',
  'el-icon-remove': 'cross',
  'el-icon-plus': 'plus',
  'el-icon-minus': 'minus',
  'el-icon-info': 'info-o',
  'el-icon-warning': 'warning-o',
  'el-icon-warning-outline': 'warning-o',
  'el-icon-error': 'cross',
  'el-icon-circle-close': 'cross',
  'el-icon-circle-close-outline': 'cross',
  'el-icon-success': 'success',
  'el-icon-circle-check': 'success',
  'el-icon-arrow-left': 'arrow-left',
  'el-icon-arrow-right': 'arrow',
  'el-icon-arrow-up': 'arrow-up',
  'el-icon-arrow-down': 'arrow-down',
  'el-icon-d-arrow-left': 'arrow-double-left',
  'el-icon-d-arrow-right': 'arrow-double-right',
  'el-icon-star-on': 'star',
  'el-icon-star-off': 'star-o',
  'el-icon-phone': 'phone',
  'el-icon-phone-outline': 'phone-o',
  'el-icon-setting': 'setting',
  'el-icon-delete': 'delete',
  'el-icon-upload': 'upload',
  'el-icon-download': 'download',
  'el-icon-picture': 'photo',
  'el-icon-picture-outline': 'photo-o',
  'el-icon-photo': 'photo',
  'el-icon-menu': 'bars',
  'el-icon-more': 'more-o',
  'el-icon-more-outline': 'more-o',
  'el-icon-user': 'contact',
  'el-icon-time': 'clock-o',
  'el-icon-date': 'calendar-o',
  'el-icon-location': 'location-o',
  'el-icon-location-outline': 'location-o',
  'el-icon-share': 'share',
  'el-icon-refresh': 'replay',
  'el-icon-loading': 'loading',
  'el-icon-sort': 'sort',
  'el-icon-sort-up': 'sort',
  'el-icon-sort-down': 'sort',
  'el-icon-finished': 'checked',
  'el-icon-circle-plus': 'add-circle',
  'el-icon-circle-plus-outline': 'add-circle-o',
  'el-icon-remove-outline': 'cross-circle-o',
  'el-icon-top': 'up',
  'el-icon-bottom': 'down',
  'el-icon-right': 'arrow',
  'el-icon-left': 'arrow-left',
  'el-icon-view': 'eye-o',
  'el-icon-camera': 'photograph',
  'el-icon-camera-solid': 'photograph',
  'el-icon-video-play': 'play',
  'el-icon-video-pause': 'pause',
  'el-icon-headset': 'headphones',
  'el-icon-s-goods': 'shopping-cart',
  'el-icon-goods': 'shopping-cart-o',
  'el-icon-wallet': 'gold-coin-o',
  'el-icon-s-marketing': 'fire',
  'el-icon-s-tools': 'setting',
  'el-icon-s-custom': 'contact',
  'el-icon-s-flag': 'flag-o',
  'el-icon-s-cooperation': 'cluster-o',
  'el-icon-s-home': 'home-o',
  'el-icon-s-shop': 'shop-o',
  'el-icon-s-comment': 'chat-o',
  'el-icon-s-check': 'checked',
  'el-icon-s-claim': 'warning-o',
  'el-icon-s-promotion': 'star',
  'el-icon-s-order': 'orders-o',
  'el-icon-s-data': 'chart',
  'el-icon-s-release': 'todo-list-o',
  'el-icon-s-ticket': 'coupon-o',
  'el-icon-s-management': 'manager-o',
  'el-icon-s-operation': 'browsing-history-o',
  'el-icon-s-open': 'folder-o',
  'el-icon-s-unfold': 'arrow-down',
  'el-icon-s-fold': 'arrow-up',
  'el-icon-s-platform': 'computer-o',
  'el-icon-s-help': 'question-o',
  'el-icon-document': 'description',
  'el-icon-document-copy': 'description',
  'el-icon-files': 'description',
  'el-icon-tickets': 'todo-list-o',
  'el-icon-notification': 'bell',
  'el-icon-message': 'chat',
  'el-icon-chat-dot-round': 'chat',
  'el-icon-chat-dot-square': 'chat-o',
  'el-icon-chat-line-round': 'chat',
  'el-icon-chat-line-square': 'chat-o',
  'el-icon-zoom-in': 'zoom-in',
  'el-icon-zoom-out': 'zoom-out',
  'el-icon-full-screen': 'enlarge',
  'el-icon-c-scale-to-original': 'shrink',
  'el-icon-rank': 'bars',
  'el-icon-sort-amount-down': 'descending',
  'el-icon-sort-amount-up': 'ascending',
  'el-icon-odometer': 'clock',
  'el-icon-data-analysis': 'chart',
  'el-icon-data-line': 'chart-trending-o',
  'el-icon-data-board': 'chart',
  'el-icon-connection': 'link-o',
  'el-icon-umbrella': 'umbrella',
  'el-icon-collection-tag': 'tag-o',
  'el-icon-aim': 'aim',
  'el-icon-switch-button': 'power-off',
  'el-icon-reading': 'eye-o',
  'el-icon-copy-document': 'description',
  'el-icon-printer': 'printer',
  'el-icon-box': 'express',
  'el-icon-link': 'link',
  'el-icon-map-location': 'location',
  'el-icon-mic': 'audio',
  'el-icon-film': 'video',
  'el-icon-sunny': 'sun',
  'el-icon-cloudy': 'cloud',
  'el-icon-light-rain': 'cloud-rain',
  'el-icon-lighning': 'lightning',
  'el-icon-snowy': 'snowflake-o',
  'el-icon-heavy-rain': 'cloud-rain'
}

export function iconMap(name) {
  if (!name) return ''
  if (iconNameMap[name]) return iconNameMap[name]
  const stripped = name.replace(/^el-icon-/, '')
  if (stripped && stripped !== name) return stripped
  return name
}
